/**
 * @author: leroy
 * @date: 2021/8/20 20:30
 * @description：_app
 */
import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import type { AppProps, NextWebVitalsMetric } from 'next/app';
import 'antd/dist/antd.variable.min.css';
import '@/styles/global.scss';
import '@/styles/var.scss';
import type { NextPage } from 'next';

import { initializeStore, StoreContext } from '@/store/store';
import { ConfigProvider } from 'antd';
import dynamic from 'next/dynamic';
import { checkServer } from '@/utils/util';
import Loading from '@/layout/Loading';
import Script from 'next/script';
import { useWhyDidYouUpdate } from 'ahooks';
const ChromeModal = dynamic(() => import('@/components/Monitor/ChromeModal'), { ssr: false });
const User = dynamic(() => import('@/layout/User'), { ssr: false });
const CreatePortal = dynamic(() => import('@/components/CreatePortal'), { ssr: false });

if (!checkServer()) {
  // 定制 antd 主题
  ConfigProvider.config({
    theme: {
      infoColor: '#19191b',
      primaryColor: '#4E6EF2',
      warningColor: '#ffa55d',
      errorColor: '#f56666',
      successColor: '#62cb6c',
    },
  });
}

// 注入store
function StoreProvider({ children, initialState }) {
  const store = initializeStore(initialState);
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}
export type NextPageWithLayout = NextPage<any> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps<{ initialState: any }> & {
  Component: NextPageWithLayout;
  err: any;
};

function MyApp({ Component, pageProps, ...props }: AppPropsWithLayout) {
  useWhyDidYouUpdate('xzxczxcxz', { pageProps, Component, ...props });

  return (
    <>
      <Script
        src="https://gosspublic.alicdn.com/aliyun-oss-sdk-6.17.0.min.js"
        strategy="afterInteractive"
      />
      <StoreProvider {...pageProps}>
        <ConfigProvider
          locale={{ locale: 'zh-cn', Image: { preview: '预览' } }}
          autoInsertSpaceInButton={false}
        >
          <CreatePortal>
            <Loading />
          </CreatePortal>
          <Component {...pageProps} />
          {/* <RemoteLoginModal isRemoteLogin={monitor.mobileDevice.status === 'forcedOffline'} />  */}
          <User />
          {/* <DisableModal /> */}
        </ConfigProvider>
      </StoreProvider>
      <ChromeModal />
    </>
  );
}

export function reportWebVitals(metric: NextWebVitalsMetric) {
  return;
  switch (metric.name) {
    // handle FCP results
    // TTFB + 内容加载时间 + 渲染时间
    case 'FCP':
      console.log('FCP 首次内容绘制', metric);
      break;
    // handle LCP results
    case 'LCP':
      console.log('LCP 最大的内容绘制', metric);
      break;
    // handle CLS results
    case 'CLS':
      console.log('CLS 累积布局偏移', metric);
      break;
    // handle FID results
    case 'FID':
      console.log('FID 首次输入延迟', metric);
      break;
    // handle TTFB results
    case 'TTFB':
      console.log('TTFB 首字节时间', metric);
      break;
    // handle route-change to render results
    case 'Next.js-route-change-to-render':
      console.log('路由改变后页面开始渲染的时间', metric);
      break;
    // handle render results
    case 'Next.js-render':
      console.log('路由更改后页面完成渲染的时间', metric);
      break;
    default:
      console.log(metric);
      break;
  }
}

export default MyApp;
